'use strict';

function fold(f, s, as) {
  return Array.from(as).reduce(f, s);
}

module.exports = fold;
